// RITA-1525 — Seitengeometrie (A4) in Millimetern und CSS-Pixeln (96 dpi).
//
// Reine Funktionen ohne DOM, damit die Seitenmaße in jsdom prüfbar sind. Die Seiten selbst werden
// im Browser in Millimetern gesetzt; Chromium rechnet 1 mm = 96/25.4 px, deshalb passen Bildschirm-
// und Druckmaße zusammen (@page A4 ohne Rand, jede Seite genau 210 × 297 mm).
import { Seiteneinstellungen } from '../model/types';

export const A4_BREITE_MM = 210;
export const A4_HOEHE_MM = 297;
export const PX_PRO_MM = 96 / 25.4;

export const mmZuPx = (mm: number): number => Math.round(mm * PX_PRO_MM * 100) / 100;
export const ptZuPx = (pt: number): number => Math.round((pt / 72) * 96 * 100) / 100;

export interface Seitengeometrie {
  breiteMm: number;
  hoeheMm: number;
  breitePx: number;
  hoehePx: number;
  kopfHoeheMm: number;
  fussHoeheMm: number;
  inhaltBreiteMm: number;
  inhaltBreitePx: number;
  inhaltHoeheMm: number;
  inhaltHoehePx: number;
}

/** Leitet aus den Seiteneinstellungen die Maße von Seite und Textbereich ab. */
export function seitengeometrie(seite: Seiteneinstellungen): Seitengeometrie {
  const { raender } = seite;
  const inhaltBreiteMm = Math.max(0, A4_BREITE_MM - raender.linksMm - raender.rechtsMm);
  const inhaltHoeheMm = Math.max(
    0,
    A4_HOEHE_MM - raender.obenMm - raender.untenMm - seite.kopfHoeheMm - seite.fussHoeheMm,
  );
  return {
    breiteMm: A4_BREITE_MM,
    hoeheMm: A4_HOEHE_MM,
    breitePx: mmZuPx(A4_BREITE_MM),
    hoehePx: mmZuPx(A4_HOEHE_MM),
    kopfHoeheMm: seite.kopfHoeheMm,
    fussHoeheMm: seite.fussHoeheMm,
    inhaltBreiteMm,
    inhaltBreitePx: mmZuPx(inhaltBreiteMm),
    inhaltHoeheMm,
    inhaltHoehePx: mmZuPx(inhaltHoeheMm),
  };
}
